<div class="chat">
	<div class="chat-messages">
		<div
			*ngIf="
            this.comments.length > 0 && this.comments.length <= this.comments.length;
            else defaultComment
         "
		>
			<div *ngFor="let comment of comments" class="chat-message-row">
				<div class="chat-message">
					<div [className]="getCommentClass(comment)">
						<p [innerHtml]="comment.text  | renderHtmlString" class="comment-text"></p>
						<span class="chip-span">
                     <p-chip
											 *ngFor="let mention of comment.mentions"
											 label="{{ mention.fullName }}"
										 ></p-chip>
                  </span>
					</div>
				</div>
				<div class="chat-message-footer">
					<h6 class="comment-name-header">
						<i *ngIf="comment.type === CommentType.Ai" class="fa-sharp fa-regular fa-robot"></i>
						{{ comment.createdUserFullName }}
					</h6>
					<span class="comment-name-date">{{
							comment.createdDate | DatePropertyTimezone: true
						}}</span>
				</div>
			</div>
		</div>
		<ng-template #defaultComment>
			<div class="-pt-6">
				<h6 class="text-right pr-6">Add comments</h6>
			</div>
		</ng-template>
	</div>
</div>
